import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { WidgetCard } from '@/shared/ui';

import styles from './PeopleCard.module.scss';

type PeopleCardProps = {
  label: ReactNode;
  children: ReactNode;
  action?: ReactNode;
  className?: string;
  dataSection?: string;
  onOpen?: () => void;
};

type TextProps = {
  children: ReactNode;
  className?: string;
};

type ActionButtonProps = TextProps & {
  onClick: () => void;
};

const PeopleCardComponent: FC<PeopleCardProps> = (props) => {
  const { label, children, action, className, dataSection, onOpen } = props;

  return (
    <WidgetCard
      className={cn(styles.container, className)}
      data-section={dataSection}
    >
      <span className={cn('p1', styles.label)}>{label}</span>

      {onOpen ? (
        <button type="button" className={styles.summary} onClick={onOpen}>
          {children}
        </button>
      ) : (
        <div className={styles.summary}>{children}</div>
      )}

      {action && <div className={styles.action}>{action}</div>}
    </WidgetCard>
  );
};

const Name: FC<TextProps> = ({ children, className }) => (
  <span className={cn('p1', styles.name, className)}>{children}</span>
);

const Count: FC<TextProps> = ({ children, className }) => (
  <span className={cn('p1', styles.count, className)}>{children}</span>
);

const Muted: FC<TextProps> = ({ children, className }) => (
  <span className={cn('p1', styles.muted, className)}>{children}</span>
);

const ActionButton: FC<ActionButtonProps> = ({
  children,
  className,
  onClick,
}) => (
  <button
    type="button"
    className={cn('p1', styles.actionButton, className)}
    onClick={onClick}
  >
    {children}
  </button>
);

type CompoundedPeopleCard = typeof PeopleCardComponent & {
  Name: typeof Name;
  Count: typeof Count;
  Muted: typeof Muted;
  ActionButton: typeof ActionButton;
};

const PeopleCard = PeopleCardComponent as CompoundedPeopleCard;

PeopleCard.Name = Name;
PeopleCard.Count = Count;
PeopleCard.Muted = Muted;
PeopleCard.ActionButton = ActionButton;

export { PeopleCard };
